import { SB } from '@play-co/replicant';
import { dreamDriftInstanceResults } from './dreamDrift.ruleset';

/** Persistent state for one timed Dream Drift run, from hero selection until completion or expiry. */
const dreamDriftInstanceSchema = SB.object({
  /** Server timestamp at which the instance began. */
  startedAt: SB.int(),
  /** Current Dream Drift progression level. */
  progress: SB.int(),
  /** Previous map position retained until its visual transition is acknowledged. */
  pendingProgress: SB.int().optional(),
  /** Progression level currently being played, or zero when no level is active. */
  playing: SB.int(),
  /** Currently selected hero, retained until the player chooses another. */
  hero: SB.string().optional(),
  /** Terminal result, present after the instance ends. */
  result: SB.tuple(dreamDriftInstanceResults).optional(),
  /** One-based number of this instance inside its event window. */
  instanceNumber: SB.int().optional(),
  /** Highest Dream Drift progression node cleared during this instance. */
  maxLevelReached: SB.int().optional(),
  /** Whether milestone reward settlement for this instance is closed. */
  claimed: SB.boolean().optional(),
});

/** Dream Drift schema fragment registered in the main player state. */
export const dreamDriftSchema = {
  dreamDrift: SB.object({
    /** Timestamp when the player most recently saw Dream Drift. */
    seenAt: SB.int().optional(),
    /** Current run, retained after it ends until the next run replaces it. */
    instance: dreamDriftInstanceSchema.optional(),
  }).optional(),
};
